/** @flow */

/* eslint no-console: 0 */
if (process.env.NODE_ENV === 'production') {
  (() => {
    if ('serviceWorker' in navigator) {
      // Removed service worker
      // $FlowFixMe
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let i = 0; i < registrations.length; i++) {
          const registration = registrations[i];
          registration.unregister();
        }
      });
      // navigator.serviceWorker.register('/service-worker.js').catch((ex) => {
      //   console.warn(ex);
      //   console.warn('(This warning can be safely ignored outside of the production build.)');
      // });
    }
  })();
}



// WEBPACK FOOTER //
// ./src/common/LoadServiceWorker.js